/* src/app/private/components/email-template/create-email-template/create-email-template.component.scss */
label {
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 12px;
}
.errors {
  font-size: 12px;
  color: red;
}
.copy-button {
  background: var(--primary-color);
  border-radius: 10px;
  color: #fff;
  padding: 2px 10px;
  font-size: 10px;
}
.dynamic-pannel {
  overflow-y: scroll !important;
  max-height: 74vh !important;
  padding-right: 10px;
  padding-bottom: 20px;
}
.dynamic-pannel::-webkit-scrollbar {
  width: 8px !important;
}
.dynamic-pannel::-webkit-scrollbar-thumb {
  background-color: var(--secondry-light-gray) !important;
  border-radius: 20px !important;
}
/*# sourceMappingURL=create-email-template.component.css.map */
